export enum ConfirmationDialogButton {
    PRIMARY = 1,
    SECONDARY = 2
}